<!-- <confirm-user *ngIf="!isConfirmed && isUserRetrieved && !isNoTenantAssigned" [user] = "user" [userTenants] = "userTenants" (onChangeUser)="onChange(user)"></confirm-user> -->
@if (isUserRetrieved && isTenantsRetrieved) {
  <confirm-user [user] = "user" [userTenants] = "userTenants" [showProfile] = true (onChangeUser)="onChange(user)"></confirm-user>
}

